export default class RulesEditor {
  constructor(client) {
    this.client = client;
    this.resourceUrl = "/rules-editor";
  }

  generateSheet(workspaceKeys) {
    return this.client.post(`${this.resourceUrl}/update`, workspaceKeys);
  }
}
